import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import ContentTagPerformanceTab from './ContentTagPerformanceTab';
import ContentTagRankingTab from './ContentTagRankingTab';

type ContentTagTab = 'performance' | 'tags-ranking';

export default function ContentTagsTab() {
  const [tab, setTab] = useState<ContentTagTab>('performance');

  return (
    <Box>
      <Tabs
        onChange={(_, value: ContentTagTab) => setTab(value)}
        sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}
        value={tab}
      >
        <Tab label="Performance" value="performance" />
        <Tab label="Tags Ranking" value="tags-ranking" />
      </Tabs>
      {tab === 'performance' && <ContentTagPerformanceTab />}
      {tab === 'tags-ranking' && <ContentTagRankingTab />}
    </Box>
  );
}
